//'use strict'
import request from './request'
import requestConfig from '../../static/http/requestConfig.js'

// 设置请求头
let setHeaders = (headers) => {
  let defaultHeaders = JSON.parse(JSON.stringify(requestConfig.headers));
  if (headers) {
    for (let key in headers) {
      defaultHeaders[key] = headers[key]
    }
  }
  return defaultHeaders;
}
// 设置请求参数
let setBody = (data,headers) => {
  if(headers){
    if(headers['Content-Type'].search("xml") != -1){
        return data;
    }
  }
  let jsonData = JSON.parse(JSON.stringify(requestConfig.body));
  for (let key in data) {
    jsonData[key] = data[key]
  }
  return jsonData;
}
// Axios请求配置
let setConfig = (url, method,data, headers)=>{
  return {
    url:url,
    method:method,
    data:setBody(data,headers),
    headers: setHeaders(headers)
  }
}

const http = {
  post: (url, data, headers) => {
    return request(setConfig(url,'POST',data,headers))
  },
  get: (url, data, headers) => {
    return request(setConfig(url,'GET',data,headers))
  },
  delete: (url, data, headers) => {
    return request(setConfig(url,'DELETE',data,headers))
  },
  put: (url, data, headers) => {
    return request(setConfig(url,'PUT',data,headers))
  },
}

export default http



// WEBPACK FOOTER //
// ./src/utils/http.js